export default "__VITE_ASSET__TPf_jpvT__"